import { useCallback, useState } from "react";

import { useQueryClient } from "components/QueryClient";

function useMutation(factory) {
  const client = useQueryClient();

  const mutation = async (variables) => {
    const { result } = await client.query(variables, factory(), true);

    return result;
  };

  return useCallback(mutation, [client, factory]);
}

export function useMutationWithState(factory) {
  const mutationFunc = useMutation(factory);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [errors, setErrors] = useState([]);

  const run = async (v) => {
    setLoading(true);

    try {
      const result = await mutationFunc(v);
      setData(result.data);
      setErrors(result.errors);

      return result;
    } catch (error) {
      setErrors([error]);
      return Promise.reject(error);
    } finally {
      setLoading(false);
    }
  };

  return [
    run,
    {
      data: data,
      errors: errors,
      loading: loading,
      isError: errors?.length > 0,
    },
  ];
}

export default useMutation;
